import { NotificationEmailList } from './../activenotifications/qaticketnotification.model';
import { NotificationsService } from './../activenotifications/notifications.service';
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MatDialogRef, ErrorStateMatcher, MatDialog } from '@angular/material';
import { ConfirmdialogComponent } from '../../dialogs/confirmdialog/confirmdialog.component';
import { InfodialogComponent } from '../../dialogs/infodialog/infodialog.component';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@Component({
  selector: "app-addnotificationemail",
  templateUrl: "./addnotificationemail.component.html",
  styleUrls: ["./addnotificationemail.component.scss"]
})

export class AddNotificationEmailComponent implements OnInit {

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  nameFormControl = new FormControl('', [
    Validators.required
  ]);

  templateFormControl = new FormControl('', [
    Validators.required
  ]);

  notificationToName: string = "";
  notificationToEmail: string = "";
  notificationTemplate: string = "";
  notificationCriticalLevel: number = -3;
  message = '';
  submitted = false;
  submitError = "";
  matcher = new MyErrorStateMatcher();
  email: NotificationEmailList;
  checked = false;

  constructor(
    public addEmailDialog: MatDialogRef<AddNotificationEmailComponent>,
    public service: NotificationsService,
    public dialog: MatDialog
  ) { }

  ngOnInit() { }

  OnCloseCancel() {
    this.addEmailDialog.close('Cancel');
  }

  OnCloseConfirm() {
    
    if (!this.emailFormControl.errors && !this.nameFormControl.errors && !this.templateFormControl.errors) {
      var emailtosave = new NotificationEmailList();
      if (this.checked) {
        if(this.notificationCriticalLevel === 0) {
          const infodialog = this.dialog.open(InfodialogComponent, {
            width: '400px',
            data: {
              title: 'Alert',
              content: 'Email with Critical Level 0 cannot be saved. Please select different Critical Level.'
            }
          });
          return;
        }
        else if (this.notificationCriticalLevel === -3) {
          const sliderdialog = this.dialog.open(ConfirmdialogComponent, {
            width: '400px',
            data: {
              title: 'Alert',
              content: 'You have selected the default Critical Level of -3 for this email. Is this correct?'
            }
          });
          sliderdialog.afterClosed().subscribe(result => {
            if (result === 'Cancel') {
              return;
            }
            else {
              emailtosave.Name = this.notificationToName;
              emailtosave.EmailAddress = this.notificationToEmail;
              emailtosave.QueueCategory = this.notificationTemplate;
              emailtosave.CriticalLevel = this.notificationCriticalLevel;
              this.addEmailDialog.close(emailtosave);
            }
          });
        }
        else {
          emailtosave.Name = this.notificationToName;
          emailtosave.EmailAddress = this.notificationToEmail;
          emailtosave.QueueCategory = this.notificationTemplate;
          emailtosave.CriticalLevel = this.notificationCriticalLevel;
          this.addEmailDialog.close(emailtosave);
        }
      }
      else {
        emailtosave.Name = this.notificationToName;
        emailtosave.EmailAddress = this.notificationToEmail;
        emailtosave.QueueCategory = this.notificationTemplate;
        emailtosave.CriticalLevel = -1000;
        this.addEmailDialog.close(emailtosave);
      }
    }
  }
}
